import React, { Component } from "react";
// import ReactDOM from 'react-dom';
import { Box } from "reactjs-admin-lte";
import {
  Button,
  ButtonToolbar,
  FormGroup,
  Row,
  Col,
  FormControl,
  Form,
  Modal,
  ButtonGroup,
} from "react-bootstrap";
// import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import FontAwsome from "react-fontawesome";
import DatePicker from "../../../component/element/DatePicker";
import CkTimePicker from "../../../component/element/CkTimePicker";
import ConfirmPopup from "../../../component/element/ConfirmPopup";
import IframeModal from "../../../component/element/IframeModal";
import WorkdocStore from "../../../stores/WorkdocStore";
import Lightbox from "react-images-extended";
import { Checkbox, Radio } from "react-icheck";
import NewContractorModal from "../../hr/NewContractorModal";
import EmployeeModal from "../../hr/EmployeeModal";
import { connect } from "react-redux";
var NotificationSystem = require("react-notification-system");
class FixingOrderDoc extends Component {
  constructor(...args) {
    super(...args);
    this.state = this.initState();
  }

  initState(newState) {
    let state = {
      loading: false,
      show: false,
      data: [],
      dataImg: { files: [] },
      currentImage: 0,
      lightboxIsOpen: false,
      images: [],
      input: [],
      colSpan: 3,
      dataWage: [],
      checkWage: [],
      _checkWage: [],
      checkWageAll: false,
      checkDelete: [],
      grossCost: 0,
      showTechnician: false,
      radioType: [false, false],
      defaultRadio: "",
      showContractorModal: false,
      showEmployeeModal: false,
      is_change_technician: false,
      confirmSaveShow: false,
      man_hour: "0",
      _man_hour: "0",
      edit_man_hour: false,
    };

    if (newState !== undefined) {
      state = Object.assign(state, newState);
    }
    return state;
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    const { workNo, technician } = nextProps;
    if (nextProps.show && nextProps.show !== this.props.show) {
      this.loadData(workNo, technician);

      if (technician.man_hour) {
        this.setState({
          man_hour: JSON.parse(JSON.stringify(technician.man_hour)),
          _man_hour: JSON.parse(JSON.stringify(technician.man_hour)),
        });
      }
    }
  }

  loadData(workNo, technician) {
    WorkdocStore.loadWorkdocFixingOrder(
      workNo,
      technician,
      (result) => {
        let grossCost =
          technician.sum_cost !== undefined ? technician.sum_cost : 0;
        let grossFlag =
          technician.gross_flag !== undefined ? technician.gross_flag : false;
        let data = result.data.map((item, index) => {
          return {
            detail: item.detail,
            quantity: item.quantity,
            price_per_unit: item.total_cost,
            orderx: item.seq,
            paint_flag: "0",
            fix_flag: "0",
            wage_cost: "",
          };
        });

        this.loadFup("quotation_job", workNo);
        this.setState({
          data: data,
          input: data,
          grossCost: grossCost,
          grossFlag: grossFlag,
        });
      },
      function (error) {}
    );
  }

  onConfirmDeleteAll(is_change_save = false) {
    let { workNo, technician, messages } = this.props;
    let { is_change_technician } = this.state;
    let delete_tec = {
      count_list: "",
      employee_id: "",
      first_name: "",
      gross_flag: "",
      last_name: "",
      nick_name: "",
      position: "",
      sum_cost: "",
      work_status: "",
    };
    if (is_change_technician) {
      delete_tec.count_list = technician.count_list;
      delete_tec.gross_flag = technician.gross_flag;
      delete_tec.sum_cost = technician.sum_cost;
      delete_tec.work_status = technician.work_status;
      delete_tec.employee_id = this.props._employee_id;
      delete_tec.first_name = this.props._first_name;
      delete_tec.last_name = this.props._last_name;
      delete_tec.nick_name = this.props._nick_name;
      delete_tec.position = this.props._position;
    } else {
      delete_tec = technician;
    }

    let meta = { work_no: workNo, gross_cost: 0, gross_flag: false };
    WorkdocStore.saveWorkdocFixingOrder(
      meta,
      delete_tec,
      [],
      (result) => {
        this.refs.notificationSystem.addNotification({
          title: messages["Notice"],
          message:
            messages["Delete All Data"] +
            " " +
            technician.first_name +
            " " +
            messages["On"] +
            " " +
            workNo,
          level: "info",
          position: "tc",
        });

        if (is_change_technician === false || is_change_save === false) {
          this.onCloseClick();
          this.setState({
            data: [],
            input: [],
            grossCost: 0,
            deleteShow: false,
            is_change_technician: false,
          });
        } else {
          this.props.onUpdateTec(technician);
          this.setState({ deleteShow: false, is_change_technician: false });
        }
      },
      function (error) {}
    );
  }

  onDateChange(e) {
    let item = { value: e };
    if (this.props.onDateChange !== undefined) this.props.onDateChange(item);
  }

  onDeleteAllClick() {
    this.setState({ deleteShow: true });
  }

  // onConfirmSave() {
  //   console.log('onConfirmSave')
  // }

  onSaveClick() {
    const { workNo, technician, messages } = this.props;
    let _technician = JSON.parse(JSON.stringify(technician));
    let {
      data,
      grossCost,
      grossFlag,
      is_change_technician,
      man_hour,
      _man_hour,
    } = this.state;
    let meta = {
      work_no: workNo,
      gross_cost: grossCost,
      gross_flag: grossFlag,
      fixing_order_date: technician.fixing_order_date,
    };
    if (man_hour !== _man_hour) {
      _technician = Object.assign({ edit_man_hour: true }, _technician);
    }
    WorkdocStore.saveWorkdocFixingOrder(
      meta,
      _technician,
      data,
      (result) => {
        if (result.status === "OK") {
          this.refs.notificationSystem.addNotification({
            title: messages["Notice"],
            message:
              messages["Save Technician Data"] +
              " " +
              technician.first_name +
              " " +
              messages["On"] +
              " " +
              workNo,
            level: "info",
            position: "tc",
          });

          if (is_change_technician) this.onConfirmDeleteAll(true);

          this.setState({
            is_change_technician: false,
            confirmSaveShow: false,
            edit_man_hour: false,
            man_hour: result.man_hour,
            _man_hour: result.man_hour,
          });
          let item = { value: result.man_hour };
          if (this.props.onManHourChange !== undefined)
            this.props.onManHourChange(item);
        }
      },
      (error) => {}
    );
  }

  onCloseClick() {
    this.setState({ is_change_technician: false });
    this.props.onBack(false);
  }

  onDeleteRowClick(item, index) {
    let { data, input, checkWage, checkWageAll, dataWage, grossCost } =
      this.state;
    if (item.orderx != "-") {
      let key = index;
      dataWage.forEach(function (items, indexs) {
        if (items.orderx == item.orderx) {
          key = indexs;
        }
      });
      checkWage[key] = false;
      checkWageAll = false;
    }

    delete data[index];
    let _data = [];
    grossCost = 0;
    data.forEach(function (item, index) {
      _data.push(item);
      grossCost += item.price_per_unit * 1;
    });

    data = _data;
    input = _data;
    this.setState({
      data: data,
      input: input,
      checkWage: checkWage,
      grossCost: grossCost,
      checkWageAll: checkWageAll,
    });
  }

  onInputChange(key, index, e) {
    let { data, input, grossCost } = this.state;
    input[index][key] = e.target.value;
    input[index]["orderx"] = "-";
    data = input;

    if (key === "price_per_unit" || key === "quantity") {
      data[index].wage_cost =
        input[index]["price_per_unit"] * input[index]["quantity"];
      grossCost = 0;
      data.map((item, index) => {
        grossCost += item.price_per_unit * item.quantity;
        return item;
      });
    }

    this.setState({
      input: input,
      data: data,
      grossCost: grossCost,
      grossFlag: 0,
    });
  }

  onRowCheckboxChange(key, index, e) {
    let { data, input } = this.state;
    input[index][key] = input[index][key] == "1" ? "0" : "1";
    data = input;
    this.setState({ input: input, data: data });
  }

  onRowAdd(number) {
    let { data } = this.state;
    for (let i = 0; i < number; i++) {
      data.push({
        itemnum: "",
        detail: "",
        quantity: "",
        price_per_unit: "",
        orderx: "-",
      });
    }
    this.setState({ data: data, input: data });
  }

  onCheckboxChange(index, type, e) {
    let { _checkWage, checkWage, checkWageAll, dataWage, checkDelete } =
      this.state;
    if (type == "all") {
      if (checkWageAll == true) {
        checkWageAll = false;
        _checkWage = [];
        checkWage.forEach(function (item, index) {
          checkWage[index] = false;
          checkDelete.push(dataWage[index]);
        });
      } else {
        checkWageAll = true;
        _checkWage = [];
        checkWage.forEach(function (item, index) {
          checkWage[index] = true;
          _checkWage.push(index);
        });
      }
    } else {
      if (checkWage[index] == true) {
        checkWage[index] = false;
        let key = _checkWage.indexOf(index);
        _checkWage.splice(key, 1);

        checkDelete.push(dataWage[index]);
      } else {
        checkWage[index] = true;
        _checkWage.push(index);
      }
      checkWageAll = false;
    }
    this.setState({
      checkWage: checkWage,
      checkWageAll: checkWageAll,
      _checkWage: _checkWage,
    });
  }

  onModalSaveClick(e) {
    let { data, input, dataWage, _checkWage, checkWageAll, checkDelete } =
      this.state;
    checkDelete.forEach(function (item, index) {
      data.forEach(function (items, indexs) {
        if (items.orderx == item.orderx) {
          delete data[indexs];
        }
      });
    });

    if (checkWageAll == true) {
      let sData = [];
      data.forEach(function (item, index) {
        if (item.orderx == "-") {
          sData.push(item);
        }
      });
      data = sData;
    }
    _checkWage.forEach(function (item, index) {
      data.push({
        itemnum: dataWage[item].wage_itemnum,
        detail: dataWage[item].detail,
        quantity: dataWage[item].quantity,
        price_per_unit: dataWage[item].wage_cost,
        orderx: dataWage[item].orderx,
        paint_flag: dataWage[item].paint_flag,
        fix_flag: dataWage[item].fix_flag,
        wage_cost: dataWage[item].wage_cost,
      });
    });

    let _data = [];
    data.forEach(function (item, index) {
      _data.push(item);
    });

    data = _data;
    input = _data;

    let grossCost = 0;
    data.map((item, index) => {
      grossCost += item.price_per_unit * 1;
      return item;
    });

    this.setState({
      show: false,
      data: data,
      input: input,
      grossCost: grossCost,
      _checkWage: [],
      checkDelete: [],
      checkWageAll: false,
      checkWage: [],
    });
  }

  onSearchClick(e) {
    let { dataWage, checkWage } = this.state;
    let that = this;

    WorkdocStore.loadWagelist(this.props.workNo, function (result) {
      result.data.forEach(function (item, index) {
        if (checkWage[index] == undefined) {
          checkWage.push(false);
        }
        if (dataWage[index] == undefined) {
          dataWage.push({
            itemnum: item.wage_itemnum,
            detail: item.detail,
            quantity: item.quantity,
            wage_cost: item.wage_cost,
            orderx: index,
            fix_flag: item.fix_flag,
            paint_flag: item.paint_flag,
          });
        }
      });

      that.setState({ dataWage: dataWage, checkWage: checkWage });
    });
    this.setState({ show: true });
  }

  onSumChange(e) {
    let { data } = this.state;
    data = data.map((item, index) => {
      item.price_per_unit = 0;
      return item;
    });
    this.setState({ data: data, grossCost: e.target.value, grossFlag: 1 });
  }

  onPrintClick(e) {
    let workNo = this.props;
    let url = "";
    if (process.env.NODE_ENV == "development") {
      url =
        "./?startPage=PrintKKCContractorQuotationDoc&wo=" +
        workNo.workNo +
        "&employee_id=" +
        this.props.technician.employee_id;
    } else {
      url =
        "./pdf/v2/?startPage=PrintKKCContractorQuotationDoc&wo=" +
        workNo.workNo +
        "&employee_id=" +
        this.props.technician.employee_id;
    }
    this.refs.iframe.loadUrl(url);
  }

  onUploadClick(e) {
    let url = "";
    if (process.env.NODE_ENV == "development") {
      url =
        "https://demo2.bigfix.co/korat/fup/?wo=" +
        this.props.workNo +
        "&cat=quotation_job";
    } else {
      url = "./fup/?wo=" + this.props.workNo + "&cat=quotation_job";
    }
    this.refs.iframeUpload.loadUrl(url);
  }

  loadFup(cat, work_no) {
    // let workNo = this.props
    let that = this;
    // workNo.workNo
    WorkdocStore.loadFup(work_no, cat, function (result) {
      that.setState({ dataImg: result.data });
    });
  }

  renderModal() {
    let { show } = this.state;
    let { messages } = this.props;
    return (
      <Modal
        bsStyle={"large"}
        show={show}
        onHide={() => {
          this.setState({
            show: false,
            checkWage: [],
            _checkWage: [],
            checkWageAll: false,
            checkDelete: [],
          });
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>{messages["All Fixing Item"]}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>{this.renderTableModal()}</Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn-primary"
            onClick={this.onModalSaveClick.bind(this)}
          >
            <FontAwsome name="thumbs-o-up" />
            &nbsp;{messages["Save"]}
          </Button>
          <Button
            className="btn-default"
            onClick={() => {
              this.setState({
                show: false,
                checkWage: [],
                _checkWage: [],
                checkWageAll: false,
                checkDelete: [],
              });
            }}
          >
            <FontAwsome name="remove" />
            &nbsp;{messages["Cancel"]}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  renderTableModal() {
    let { dataWage, checkWageAll } = this.state;
    let { showSalePrice, messages } = this.props;
    return (
      <table className="table table-responsive table-bordered-solid">
        <thead>
          <tr>
            <th className="text-center" style={{ width: "30px" }}></th>
            <th className="text-center">{messages["Detail"]}</th>
            {showSalePrice ? (
              <th style={{ width: "100px" }} className="text-center">
                {messages["Hit-Paint"]}
              </th>
            ) : (
              ""
            )}
            {showSalePrice ? (
              <th style={{ width: "100px" }} className="text-center">
                {messages["Fixing"]}
              </th>
            ) : (
              ""
            )}
            {showSalePrice ? (
              <th style={{ width: "100px" }} className="text-center">
                {messages["Control Price"]}
              </th>
            ) : (
              ""
            )}
          </tr>
        </thead>
        <tbody>
          <tr key={99} style={{ display: dataWage.length === 0 ? "none" : "" }}>
            <td className="text-center">
              <Checkbox
                checked={checkWageAll}
                checkboxClass="icheckbox_square-blue"
                increaseArea="20%"
                label=""
                onChange={this.onCheckboxChange.bind(this, "", "all")}
              ></Checkbox>
            </td>
            <td colSpan={4}>{messages["Select All"]}</td>
          </tr>
          {this.renderRowDataModal()}
        </tbody>
      </table>
    );
  }

  renderRowDataModal() {
    let { dataWage, checkWage } = this.state;
    let { showSalePrice, messages } = this.props;
    if (dataWage.length === 0) {
      return (
        <tr>
          <td colSpan={showSalePrice ? 5 : 2}>{messages["No Data"]}</td>
        </tr>
      );
    } else {
      return dataWage.map((item, index) => {
        return (
          <tr key={index}>
            <td className="text-center">
              <Checkbox
                checked={checkWage[index]}
                checkboxClass="icheckbox_square-blue"
                increaseArea="20%"
                label=""
                onChange={this.onCheckboxChange.bind(this, index, "")}
              ></Checkbox>
            </td>
            <td>{item.detail}</td>
            {showSalePrice ? (
              <td className="text-center">
                <Checkbox
                  readOnly={true}
                  checked={item.paint_flag == "1" ? true : false}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"
                  label=""
                  onChange={() => {}}
                ></Checkbox>
              </td>
            ) : (
              ""
            )}
            {showSalePrice ? (
              <td className="text-center">
                <Checkbox
                  readOnly={true}
                  checked={item.fix_flag == "1" ? true : false}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"
                  label=""
                  onChange={() => {}}
                ></Checkbox>
              </td>
            ) : (
              ""
            )}
            {showSalePrice ? (
              <td className="text-center">{item.wage_cost}</td>
            ) : (
              ""
            )}
          </tr>
        );
      });
    }
  }

  renderRowData() {
    let { data, input } = this.state;
    let { showSalePrice, messages } = this.props;
    console.log("data", data);
    if (data.length === 0) {
      return (
        <tr>
          <td colSpan={showSalePrice ? 8 : 5}>
            {this.props.messages["No Data"]}
          </td>
        </tr>
      );
    } else {
      return data.map((item, index) => {
        let sum_wage_cost = 0;
        let price_per_unit = input[index].price_per_unit;
        price_per_unit =
          price_per_unit && !isNaN(price_per_unit) ? price_per_unit : 0;
        let quantity = input[index].quantity;
        quantity = quantity && !isNaN(quantity) ? quantity : 0;
        sum_wage_cost = price_per_unit * quantity;
        return (
          <tr key={index}>
            <td className="text-center">{index + 1}</td>
            <td className="data-column">
              <FormControl
                value={input[index].detail}
                onChange={this.onInputChange.bind(this, "detail", index)}
              />
            </td>
            <td className="data-column text-center">
              <FormControl
                className="text-center"
                value={input[index].quantity}
                onChange={this.onInputChange.bind(this, "quantity", index)}
              />
            </td>
            <td className="data-column text-right">
              <FormControl
                className="text-right"
                value={input[index].price_per_unit}
                onChange={this.onInputChange.bind(
                  this,
                  "price_per_unit",
                  index
                )}
              />
            </td>
            {showSalePrice ? (
              <td className="data-column text-center">
                <Checkbox
                  checked={input[index].paint_flag == "1" ? true : false}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"
                  label=""
                  onChange={this.onRowCheckboxChange.bind(
                    this,
                    "paint_flag",
                    index
                  )}
                ></Checkbox>
              </td>
            ) : (
              ""
            )}
            {showSalePrice ? (
              <td className="data-column text-center">
                <Checkbox
                  checked={input[index].fix_flag == "1" ? true : false}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"
                  label=""
                  onChange={this.onRowCheckboxChange.bind(
                    this,
                    "fix_flag",
                    index
                  )}
                ></Checkbox>
              </td>
            ) : (
              ""
            )}
            {showSalePrice ? (
              <td className="data-column text-right">
                <FormControl
                  readOnly={true}
                  className="text-right"
                  value={input[index].wage_cost}
                  onChange={this.onInputChange.bind(this, "wage_cost", index)}
                />
              </td>
            ) : (
              ""
            )}
            <td className="text-right" style={{ verticalAlign: "middle" }}>
              {sum_wage_cost}
            </td>
            <td className="text-center">
              <Button
                bsStyle={"danger"}
                onClick={this.onDeleteRowClick.bind(this, item, index)}
              >
                <FontAwsome name="eraser" />
                &nbsp;{messages["Delete"]}
              </Button>
            </td>
          </tr>
        );
      });
    }
  }

  renderEmployeeType(workStatus) {
    let { messages } = this.props;
    if (workStatus === "contractor") {
      return <span>{messages["Contractor"]}</span>;
    } else {
      return <span>{messages["Employee"]}</span>;
    }
  }

  convertJobDate(value) {
    if (value !== "" && value !== null && value !== undefined) {
      if (value.substring(0, 10) !== " ") return value.substring(0, 10);
      else return "";
    }
    return "";
  }

  convertJobTime(value) {
    if (value !== "" && value !== null && value !== undefined) {
      if (value.substring(10) !== " ") return value.substring(10);
      else return "";
    }
    return "";
  }

  onJobDateChange(field, e) {
    if (e !== "" && e !== null && e !== undefined) {
      let { technician } = this.props;
      let value = e + " " + this.convertJobTime(technician[field]);
      let item = { field: field, value: value };
      if (this.props.onJobDateChange !== undefined)
        this.props.onJobDateChange(item);
    }
  }

  onJobTimeChange(field, e) {
    let { technician } = this.props;
    if (
      e !== "" &&
      e !== null &&
      e !== undefined &&
      technician[field] !== "" &&
      technician[field] !== null &&
      technician[field] !== undefined
    ) {
      let value = this.convertJobDate(technician[field]) + " " + e;
      let item = { field: field, value: value };
      if (this.props.onJobDateChange !== undefined)
        this.props.onJobDateChange(item);
    }
  }

  onManHourChange(e) {
    this.setState({ man_hour: e.target.value });
    let item = { value: e.target.value };
    if (this.props.onManHourChange !== undefined)
      this.props.onManHourChange(item);
  }

  onEditManHourClick() {
    let { edit_man_hour } = this.state;
    if (edit_man_hour) edit_man_hour = false;
    else edit_man_hour = true;
    this.setState({ edit_man_hour: edit_man_hour });
  }

  renderHead() {
    let { man_hour, edit_man_hour } = this.state;
    let { messages } = this.props;
    if (this.props.technician != undefined) {
      return (
        <div>
          <p>
            {messages["Full Name"]} : {this.props.technician.first_name}{" "}
            {this.props.technician.last_name}&nbsp;
            <Button
              onClick={() => this.setState({ showTechnician: true })}
              className="btn btn-xs btn-primary"
            >
              <FontAwsome name="pencil" />
              &nbsp;{messages["Change Technician"]}
            </Button>
          </p>
          <p>
            {messages["Position"]} : {this.props.technician.position}
          </p>
          <p>
            {messages["Type"]} :{" "}
            {this.renderEmployeeType(this.props.technician.work_status)}
          </p>
          <div style={{ display: "inline-flex" }}>
            <p>{messages["Date Document"]} :&nbsp;</p>
            <DatePicker
              showIcon={true}
              showFooter={true}
              popPlacement="bottom"
              buddhistEra
              value={this.props.technician.fixing_order_date}
              onChange={this.onDateChange.bind(this)}
              maxWidth="100%"
            />
          </div>
          <div style={{ marginTop: "10px" }}>
            <table
              className="table table-hover table-bordered-solid"
              style={{ marginBottom: "0" }}
            >
              <thead>
                <tr>
                  <th className="text-center">{messages["Start Job Date"]}</th>
                  <th className="text-center">{messages["End Job Date"]}</th>
                  <th className="text-center">{messages["Duration"]}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ padding: "0px" }}>
                    <div style={{ display: "table-row" }}>
                      <div className="bt-td-left">{messages["Date"]}</div>
                      <div
                        className="bt-td-right text-center"
                        style={{ width: "100%" }}
                      >
                        <DatePicker
                          showIcon={true}
                          showFooter={false}
                          popPlacement="bottom"
                          buddhistEra
                          value={this.convertJobDate(
                            this.props.technician.start_job_date
                          )}
                          onChange={this.onJobDateChange.bind(
                            this,
                            "start_job_date"
                          )}
                          maxWidth="120px"
                        />
                      </div>
                    </div>
                    <div style={{ display: "table-row" }}>
                      <div className="bt-td-left">{messages["Time"]}</div>
                      <div
                        className="bt-td-right text-center"
                        style={{ width: "100%" }}
                      >
                        <CkTimePicker
                          minuteStep={5}
                          value={this.convertJobTime(
                            this.props.technician.start_job_date
                          )}
                          onTimeSaved={this.onJobTimeChange.bind(
                            this,
                            "start_job_date"
                          )}
                        />
                      </div>
                    </div>
                  </td>
                  <td style={{ padding: "0px" }}>
                    <div style={{ display: "table-row" }}>
                      <div className="bt-td-left">{messages["Date"]}</div>
                      <div
                        className="bt-td-right text-center"
                        style={{ width: "100%" }}
                      >
                        <DatePicker
                          showIcon={true}
                          showFooter={false}
                          popPlacement="bottom"
                          buddhistEra
                          value={this.convertJobDate(
                            this.props.technician.end_job_date
                          )}
                          onChange={this.onJobDateChange.bind(
                            this,
                            "end_job_date"
                          )}
                          maxWidth="120px"
                        />
                      </div>
                    </div>
                    <div style={{ display: "table-row" }}>
                      <div className="bt-td-left">{messages["Time"]}</div>
                      <div
                        className="bt-td-right text-center"
                        style={{ width: "100%" }}
                      >
                        <CkTimePicker
                          minuteStep={5}
                          value={this.convertJobTime(
                            this.props.technician.end_job_date
                          )}
                          onTimeSaved={this.onJobTimeChange.bind(
                            this,
                            "end_job_date"
                          )}
                        />
                      </div>
                    </div>
                  </td>
                  <td
                    className="text-center"
                    style={{ verticalAlign: "middle" }}
                  >
                    {edit_man_hour ? (
                      <FormControl
                        className="text-center"
                        style={{ width: "100px", display: "inline-block" }}
                        onChange={this.onManHourChange.bind(this)}
                        value={man_hour}
                      />
                    ) : (
                      man_hour
                    )}
                    &nbsp;
                    <FontAwsome
                      onClick={this.onEditManHourClick.bind(this)}
                      style={{ cursor: "pointer" }}
                      name="pencil"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      );
    }
  }

  renderSum() {
    let { data } = this.state;
    let sum = 0;
    data.forEach(function (item, index) {
      if (
        item.quantity === "" ||
        item.quantity === null ||
        item.quantity === undefined ||
        isNaN(item.quantity)
      )
        item.quantity = 0;

      if (
        item.price_per_unit === "" ||
        item.price_per_unit === null ||
        item.price_per_unit === undefined ||
        isNaN(item.price_per_unit)
      )
        item.price_per_unit = 0;

      sum = parseFloat(sum) + item.quantity * item.price_per_unit;
    });
    return (
      <FormControl
        className="text-right"
        value={sum}
        onChange={this.onSumChange.bind(this)}
      />
    );
  }

  renderTable() {
    let { showSalePrice, messages } = this.props;
    return (
      <table className="table table-responsive table-hover table-bordered-solid">
        <thead>
          <tr>
            <th className="text-center" style={{ width: "30px" }}>
              {messages["No"]}
            </th>
            <th className="text-center">{messages["Wage List"]}</th>
            <th className="text-center" style={{ width: "120px" }}>
              {messages["Quantity"]}
            </th>
            <th className="text-center" style={{ width: "150px" }}>
              {messages["Wage Per Unit"]}
            </th>
            {showSalePrice ? (
              <th className="text-center" style={{ width: "100px" }}>
                {messages["Hit-Paint"]}
              </th>
            ) : (
              ""
            )}
            {showSalePrice ? (
              <th className="text-center" style={{ width: "100px" }}>
                {messages["Fixing"]}
              </th>
            ) : (
              ""
            )}
            {showSalePrice ? (
              <th className="text-center" style={{ width: "100px" }}>
                {messages["Control Price"]}
              </th>
            ) : (
              ""
            )}
            <th className="text-center" style={{ width: "120px" }}>
              {messages["Total Wages"]}
            </th>
            <th className="text-center" style={{ width: "30px" }}>
              {messages["Delete"]}
            </th>
          </tr>
        </thead>
        <tbody>{this.renderRowData()}</tbody>
        <tfoot>
          <tr>
            <th colSpan="4" className="text-right">
              {messages["Total Wages"]}
            </th>
            <th className="data-column text-right">{this.renderSum()}</th>
            <th colSpan={showSalePrice ? 5 : 1}></th>
          </tr>
        </tfoot>
      </table>
    );
  }

  renderNewItemButton() {
    let { messages } = this.props;
    return (
      <div style={{ display: "inline-flex" }}>
        <ButtonToolbar>
          <Button className="bg-olive" onClick={this.onRowAdd.bind(this, 1)}>
            <FontAwsome name="plus" />
            &nbsp;{messages["Add Row"]}
          </Button>
          <Button className="bg-olive" onClick={this.onRowAdd.bind(this, 10)}>
            <FontAwsome name="plus" />
            &nbsp;{messages["Add 10 Row"]}
          </Button>
          <Button
            className="btn btn-primary"
            onClick={this.onUploadClick.bind(this)}
          >
            <FontAwsome name="file-image-o" />
            &nbsp;{messages["Image File"]}
          </Button>
          <Button
            className="btn btn-warning"
            onClick={this.onSearchClick.bind(this)}
          >
            <FontAwsome name="search" />
            &nbsp;{messages["Search Fixing Item"]}
          </Button>
        </ButtonToolbar>
      </div>
    );
  }

  onCheckChange(e) {
    // let {checkedImg} = this.state
    // checkedImg[index] = !checkedImg[index]
    // this.setState({checkedImg:checkedImg})
  }

  onImgClick(index, e) {
    let { images, dataImg } = this.state;
    dataImg.files.forEach((element) => {
      images.push({
        src: element.url,
        thumbnail: element.thumbnailUrl,
        srcset: [element.url],
        caption: element.name,
      });
    });

    this.setState({
      currentImage: index,
      lightboxIsOpen: true,
      images: images,
    });
  }

  onClickImage() {
    let { dataImg } = this.state;
    if (this.state.currentImage === 0) {
      this.onClickNext();
    } else if (this.state.currentImage === dataImg.files.length - 1) {
      this.onClickPrevious();
    }
  }

  onClickNext() {
    this.setState({
      currentImage: this.state.currentImage + 1,
    });
  }

  onClickPrevious() {
    this.setState({
      currentImage: this.state.currentImage - 1,
    });
  }

  onCloseLightbox() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
      images: [],
    });
  }

  renderImgZone() {
    let { dataImg } = this.state;
    let { messages } = this.props;
    if (dataImg.files.length > 0) {
      return dataImg.files.map((item, index) => {
        return (
          <Col key={index} className="col-md-15 template-download">
            <div className="thumb-box">
              <input
                type="checkbox"
                onChange={this.onCheckChange.bind(this, item, index)}
              />
              <span
                className="preview"
                onClick={this.onImgClick.bind(this, index)}
              >
                <a href="#" title="">
                  <img src={item.thumbnailUrl} className="img-auto-width" />
                </a>
              </span>
              <div style={{ display: "flex" }}>
                <p className="name">
                  <a href="#">{item.name}</a>
                </p>
              </div>
              <div className="footer-box" style={{ display: "flex" }}>
                {item.createddate}
              </div>
            </div>
          </Col>
        );
      });
    } else {
      return <div className="text-center">{messages["No Image"]}</div>;
    }
  }

  onUpImgHide(e) {
    this.loadFup("quotation_job", this.props.workNo);
    // this.loadData(this.props.workNo,this.props.technician)
  }

  onTechnicianCloseClick() {
    let { radioType, defaultRadio } = this.state;
    radioType[0] = false;
    radioType[1] = false;
    defaultRadio = "";
    this.setState({
      showTechnician: false,
      radioType: radioType,
      defaultRadio: defaultRadio,
    });
  }

  onRadioChange(key, e) {
    let { radioType, defaultRadio } = this.state;
    let { showContractorModal, showEmployeeModal } = this.state;
    if (key === "out") {
      radioType[0] = true;
      radioType[1] = false;
      defaultRadio = "out";
      showContractorModal = true;
      showEmployeeModal = false;
    } else if (key === "in") {
      radioType[0] = false;
      radioType[1] = true;
      defaultRadio = "in";
      showContractorModal = false;
      showEmployeeModal = true;
    }
    this.setState({
      radioType: radioType,
      defaultRadio: defaultRadio,
      showContractorModal: showContractorModal,
      showEmployeeModal: showEmployeeModal,
    });
  }

  onSelect(item) {
    let { defaultRadio, radioType } = this.state;
    let { technician, messages } = this.props;

    technician.employee_id = item.employee_id;
    technician.first_name = item.first_name;
    technician.last_name = item.last_name;
    technician.nick_name = item.nick_name;
    technician.position = item.position;
    technician.work_status =
      item.status_text === messages["Contractor"] ? "contractor" : "";

    radioType[0] = false;
    radioType[1] = false;
    defaultRadio = "";
    this.setState({
      showTechnician: false,
      radioType: radioType,
      defaultRadio: defaultRadio,
      is_change_technician: true,
    });
  }

  render() {
    let { loading, deleteShow } = this.state;
    let { show, messages } = this.props;
    return (
      <div style={{ display: show ? "" : "none" }}>
        <Box loading={loading}>
          <Box.Header>
            <Box.Title>{this.renderHead()}</Box.Title>
            <Box.Tools>
              <ButtonToolbar>
                <ButtonGroup>
                  <Button
                    className="btn-box-tool bg-maroon"
                    onClick={this.onPrintClick.bind(this)}
                  >
                    <FontAwsome name="print" />
                    &nbsp;{messages["Print"]}
                  </Button>
                </ButtonGroup>
              </ButtonToolbar>
            </Box.Tools>
          </Box.Header>
          <Box.Body>
            {this.renderTable()}
            {this.renderNewItemButton()}
            <Row>
              <Col md={12}>
                <hr />
              </Col>
            </Row>
            <Row>{this.renderImgZone()}</Row>
            <IframeModal
              ref="iframeUpload"
              title={messages["Upload Image"]}
              modal={true}
              onUpImgHide={this.onUpImgHide.bind(this)}
            />
            <IframeModal ref="iframe" title={messages["Print Document"]} />
            <NotificationSystem ref="notificationSystem" />
            <Lightbox
              currentImage={this.state.currentImage}
              images={this.state.images}
              isOpen={this.state.lightboxIsOpen}
              rotatable={true}
              zoomable={true}
              onClickImage={this.onClickImage.bind(this)}
              onClickNext={this.onClickNext.bind(this)}
              onClickPrev={this.onClickPrevious.bind(this)}
              onClose={this.onCloseLightbox.bind(this)}
            />
            {this.renderModal()}
            <ConfirmPopup
              show={deleteShow}
              title={messages["Confirm"]}
              message={messages["Want Delete All Items"]}
              confirmTitle={messages["Confirm"]}
              onConfirm={this.onConfirmDeleteAll.bind(this, false)}
              onHide={() => {
                this.setState({ deleteShow: false });
              }}
            />
            <ConfirmPopup
              show={this.state.confirmSaveShow}
              title={messages["Confirm Change Technician"]}
              message={
                messages["Want Change Technician From"] +
                " " +
                this.props._first_name +
                " " +
                messages["To"] +
                " " +
                this.props.technician.first_name +
                " " +
                messages["Or Not"]
              }
              confirmTitle={messages["Confirm"]}
              onConfirm={this.onSaveClick.bind(this)}
              onHide={() => {
                this.setState({ confirmSaveShow: false });
              }}
            />
          </Box.Body>
          <Box.Footer>
            <ButtonToolbar className="pull-right">
              <Button onClick={this.onDeleteAllClick.bind(this)}>
                <FontAwsome name="eraser" />
                &nbsp;{messages["Delete All Items"]}
              </Button>
              <Button
                bsStyle="primary"
                onClick={
                  this.state.is_change_technician
                    ? () => {
                        this.setState({ confirmSaveShow: true });
                      }
                    : this.onSaveClick.bind(this)
                }
              >
                <FontAwsome name="save" />
                &nbsp;{messages["Save"]}
              </Button>
              <Button onClick={this.onCloseClick.bind(this)}>
                <FontAwsome name="close" />
                &nbsp;{messages["Back"]}
              </Button>
            </ButtonToolbar>
          </Box.Footer>
        </Box>
        <Modal
          show={this.state.showTechnician}
          onHide={this.onTechnicianCloseClick.bind(this)}
        >
          <Modal.Header closeButton>
            <Modal.Title>{messages["Responsible Person"]}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <FormGroup>
                <Radio
                  checked={this.state.radioType[0]}
                  radioClass="iradio_square-blue"
                  increaseArea="20%"
                  label={" " + messages["Contractor"]}
                  onChange={this.onRadioChange.bind(this, "out")}
                ></Radio>
                {""}
                <Radio
                  checked={this.state.radioType[1]}
                  radioClass="iradio_square-blue"
                  increaseArea="20%"
                  label={" " + messages["Employee"]}
                  onChange={this.onRadioChange.bind(this, "in")}
                ></Radio>
              </FormGroup>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn-default"
              onClick={this.onTechnicianCloseClick.bind(this)}
            >
              <FontAwsome name="remove" />
              &nbsp;{messages["Close"]}
            </Button>
          </Modal.Footer>
        </Modal>
        <NewContractorModal
          show={this.state.showContractorModal}
          onHide={() => {
            this.setState({ showContractorModal: false });
          }}
          onSelect={this.onSelect.bind(this)}
        ></NewContractorModal>
        <EmployeeModal
          show={this.state.showEmployeeModal}
          onHide={() => {
            this.setState({ showEmployeeModal: false });
          }}
          onSelect={this.onSelect.bind(this)}
        ></EmployeeModal>
      </div>
    );
  }
}

FixingOrderDoc.defaultProps = {
  show: false,
  showSalePrice: false,
};

export default FixingOrderDoc = connect(
  (state) => ({
    messages: state.message.view.workdoc.jobcontrol.FixingOrderDoc,
  }),
  null,
  null,
  { withRef: true }
)(FixingOrderDoc);



// WEBPACK FOOTER //
// ./src/view/workdoc/jobcontrol/FixingOrderDoc.js